import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React, { useRef, useState, useEffect } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import HeaderBrandDepth from '../header/HeaderBrandDepth.js';
import HeaderBrandMain from '../header/HeaderBrandMain.js';
import HeaderBrandWindow from '../header/HeaderBrandWindow.js';
import LineTabFixedMain from '../tab/LineTabFixedMain.js';
import LineTabFixedSub from '../tab/LineTabFixedSub.js';
import LineTabFlexibleMain from '../tab/LineTabFlexibleMain.js';
import '../../constants/bottomNavigationBar.js';
import '../../constants/footer.js';
import '../../constants/footerQuickMenuItem.js';
import { RESPONSIVE } from '../../constants/global.js';
import useHeightOfElement from '../../hooks/useHeightOfElement.js';
import useScrollY, { SCROLL_DIRECTION } from '../../hooks/useScrollY.js';
import { isProduction } from '../../utils/env.js';
import { hasChildComponent } from '../../utils/react.js';
import styles from './StickyHeaderArea.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function StickyHeaderAreaInner(_ref) {
  var header = _ref.header,
    children = _ref.children,
    scrollTarget = _ref.scrollTarget,
    setHeight = _ref.setHeight,
    $containerRef = _ref.$containerRef,
    isFixedHeader = _ref.isFixedHeader;
  var $ref = $containerRef !== null && $containerRef !== void 0 ? $containerRef : useRef(null);
  var $headerRef = useRef(null);
  var headerHeight = useHeightOfElement($headerRef);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hideHeader = _useState2[0],
    setHideHeader = _useState2[1];
  var _useScrollY = useScrollY({
      scrollTarget: scrollTarget
    }),
    direction = _useScrollY.direction,
    position = _useScrollY.position;
  var isScrolled = position > 0;
  useIsomorphicLayoutEffect(function () {
    $ref.current && setHeight($ref.current.offsetHeight);
  }, [setHeight, $ref]);
  var scrollOverHeaderOffset = position > headerHeight;
  useEffect(function () {
    var isDesktopLayout = window.matchMedia("(min-width: ".concat(RESPONSIVE.DESKTOP, "px)")).matches;
    if (isDesktopLayout || isFixedHeader) {
      hideHeader && setHideHeader(false);
    } else {
      if (direction === SCROLL_DIRECTION.UP && scrollOverHeaderOffset) {
        setHideHeader(true);
      } else {
        setHideHeader(false);
      }
    }
  }, [direction, hideHeader, scrollOverHeaderOffset, position, isFixedHeader]);
  useIsomorphicLayoutEffect(function () {
    if (!header && !children && !isProduction) {
      // eslint-disable-next-line no-console
      console.warn('StickyHeaderArea는 header나 children 중 최소 한 개 이상을 정의해야 합니다.');
    }
  }, [children, header]);
  var hasHeaderComponent = hasChildComponent({
    children: children,
    targetComponent: [HeaderBrandMain, HeaderBrandDepth, HeaderBrandWindow]
  });
  useIsomorphicLayoutEffect(function () {
    if (hasHeaderComponent && !isProduction) {
      // eslint-disable-next-line no-console
      console.warn('children prop에 Header를 정의하고 있습니다. Header는 header prop에 정의해주세요.');
    }
  }, [hasHeaderComponent]);
  var scrollIsGoingToTop = !hideHeader && direction === SCROLL_DIRECTION.DOWN && isScrolled;
  var isFixedHeaderOnly = isFixedHeader && !children;
  var isDynamicHeaderOnly = !isFixedHeader && !children;
  var scrollBorderStyle = isDynamicHeaderOnly && scrollIsGoingToTop || isFixedHeaderOnly && isScrolled;
  var childrenIsLineTab = hasChildComponent({
    children: children,
    targetComponent: [LineTabFixedMain, LineTabFixedSub, LineTabFlexibleMain]
  }, {
    searchDeep: true
  });
  return /*#__PURE__*/React.createElement("div", {
    // [D] 마크업 확인용
    className: cx('article', {
      'scroll-border': scrollBorderStyle && (!hideHeader || !header)
    }),
    ref: $containerRef !== null && $containerRef !== void 0 ? $containerRef : $ref,
    style: {
      transform: hideHeader ? "translateY(".concat(-headerHeight, "px)") : 'translateY(0)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: $headerRef
  }, header), /*#__PURE__*/React.createElement("div", {
    className: childrenIsLineTab ? cx('line-tab', "line-tab-scroll-".concat(hideHeader ? 'down' : 'up')) : ''
  }, children));
}

export { StickyHeaderAreaInner as default };
